import schema from './schema.json';

export default {
  ...schema,

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      if (data.blocks) {
        data.blocks = data.blocks.map((block, index) => ({
          id: block.id || `block-${index + 1}`,
          ...block
        }));
      }
      return { ...schema.default, ...data };
    }
    return data;
  }
};
